module.exports = __webpack_public_path__ + "static/media/filled_bar_AERO_hand.3eb30924.svg";